var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSessionTimeout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 120 110",
    style: {
      enableBackground: "new 0 0 120 110"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#F1F0EE;}\r\n\t.st1{fill:#D2D2D2;}\r\n\t.st2{fill:#C1C0BF;}\r\n\t.st3{fill:#B4B3B2;}\r\n\t.st4{fill:#A6A5A5;}\r\n\t.st5{fill:#FFFFFF;}\r\n\t.st6{fill:#D53D3D;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_00000054241668782499471000000014549648170772981162_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55482_00000163753784941751809450000007362948912651709570_",
    className: "st0",
    d: "M113.1138,48.7926 c1.1312,22.9883-22.722,35.409-43.5294,42.347c-20.1152,6.7072-44.2679,9.09-56.6123-8.9561 C0.7075,64.2547,9.2874,39.7982,23.0704,23.1411c10.4657-12.6478,27.5571-9.4106,42.9225-5.0334 C85.6941,23.7205,112.0564,27.2943,113.1138,48.7926"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st1",
    cx: 107.5949,
    cy: 1.78,
    rx: 1.806,
    ry: 1.78
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st1",
    cx: 108.954,
    cy: 12.2503,
    rx: 0.903,
    ry: 0.89
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 4.9577,
    className: "st2",
    width: 2.1323,
    height: 0.6273
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 5.7515,
    y: 4.2205,
    className: "st2",
    width: 0.6293,
    height: 2.1015
  }))), /*#__PURE__*/React.createElement("ellipse", {
    className: "st1",
    cx: 17.868,
    cy: 9.1333,
    rx: 0.903,
    ry: 0.89
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st1",
    cx: 6.8419,
    cy: 18.5661,
    rx: 0.903,
    ry: 0.89
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st1",
    cx: 58.1224,
    cy: 108.22,
    rx: 1.806,
    ry: 1.78
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st1",
    cx: 40.007,
    cy: 105.1382,
    rx: 0.903,
    ry: 0.89
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st1",
    cx: 6.8419,
    cy: 89.0114,
    rx: 0.903,
    ry: 0.89
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_63401_00000016781823452219193840000014487724862921915036_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Line_3298_00000154394900589655484820000012824155417673984923_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 111.9007,
    y: 86.1394,
    className: "st3",
    width: 3.0993,
    height: 0.6267
  })), /*#__PURE__*/React.createElement("g", {
    id: "Line_3299_00000170977333911788415600000014160368406739561886_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 113.1364,
    y: 84.9255,
    className: "st3",
    width: 0.6286,
    height: 3.0538
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000114036174380981489930000016483985632334632076_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M84.7314,91.1798v2.38c0,0.93-0.75,1.68-1.68,1.68h-52.11c-0.92,0-1.68-0.75-1.68-1.68v-2.38 c0-0.93,0.76-1.68,1.68-1.68h1.68c-0.42-10.58,5.83-21.29,15.96-26.79c3.36-1.82,3.25-2.78,2.88-3.53 c-0.38-0.76-1.52-1.43-2.52-2.03c-0.24-0.14-0.48-0.28-0.69-0.42c-4.19-2.6-8.18-5.33-11.05-10.05 c-3.31-5.44-3.88-11.2-3.96-16.17h-2.3c-0.92,0-1.68-0.76-1.68-1.69v-2.38c0-0.93,0.76-1.68,1.68-1.68h52.11 c0.93,0,1.68,0.75,1.68,1.68v2.38c0,0.93-0.75,1.69-1.68,1.69h-1.57c-0.07,4.97-0.64,10.73-3.95,16.17 c-2.87,4.72-6.87,7.45-11.05,10.05c-0.22,0.14-0.45,0.28-0.69,0.42c-1.01,0.6-2.15,1.27-2.52,2.03 c-0.37,0.75-0.49,1.71,2.87,3.53c10.13,5.5,16.38,16.21,15.96,26.79h0.95C83.9814,89.4998,84.7314,90.2498,84.7314,91.1798z  M78.7314,89.4998c0.4-9.27-5.28-19-14.19-23.83c-4.31-2.34-5.75-5.03-4.28-7.98c0.81-1.65,2.47-2.64,3.81-3.43 c0.22-0.13,0.43-0.26,0.63-0.38c3.97-2.47,7.47-4.85,9.96-8.95c2.88-4.73,3.39-9.92,3.46-14.42h-41.52 c0.08,4.5,0.59,9.69,3.47,14.42c2.49,4.1,5.98,6.48,9.95,8.95c0.2,0.12,0.41,0.25,0.63,0.38c1.34,0.79,3,1.78,3.82,3.43 c1.46,2.95,0.02,5.64-4.28,7.98c-8.91,4.83-14.59,14.56-14.2,23.83H78.7314z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M64.5414,65.6698c8.91,4.83,14.59,14.56,14.19,23.83h-42.74c-0.39-9.27,5.29-19,14.2-23.83 c4.3-2.34,5.74-5.03,4.28-7.98c-0.82-1.65-2.48-2.64-3.82-3.43c-0.22-0.13-0.43-0.26-0.63-0.38c-3.97-2.47-7.46-4.85-9.95-8.95 c-2.88-4.73-3.39-9.92-3.47-14.42h41.52c-0.07,4.5-0.58,9.69-3.46,14.42c-2.49,4.1-5.99,6.48-9.96,8.95 c-0.2,0.12-0.41,0.25-0.63,0.38c-1.34,0.79-3,1.78-3.81,3.43C58.7914,60.6398,60.2314,63.3298,64.5414,65.6698z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M50.6031,50.7712c0.985,0.2656,2.4555,0.7964,3.9549,1.9114c0.9669,0.719,1.6759,1.4802,2.1753,2.1091 c0,5.9983,0,11.9968,0,17.9951c-1.1513,0.0039-3.9567,0.1829-6.0303,2.2234c-0.3538,0.3481-0.647,0.7119-0.8908,1.0728 c-0.6213-0.0225-4.3676-0.0959-7.2848,2.8538c-3.3479,3.3855-2.7437,7.8611-2.6687,8.3521c11.7772,0,23.5542,0,35.3311,0 c0.0514-0.7295-0.0525-1.3242-0.1863-1.7742c-0.9176-3.0864-4.6508-4.1113-5.087-4.2244c-0.4073-0.6433-1.0335-1.5564-1.9114-2.571 c-0.3904-0.4512-0.5856-0.6768-0.7938-0.8674c-1.3134-1.2021-3.2964-1.8853-5.1387-1.7688 c-0.7769,0.0491-0.9968,0.2004-1.5821,0.0659c-1.2749-0.2932-1.9196-1.3665-2.0435-1.5825 c-0.088-6.5474-0.1757-13.0947-0.2636-19.6428c0.6105-0.7043,1.6001-1.7014,3.0321-2.5706 c0.4075-0.2471,0.8412-0.4565,0.8415-0.4565c0.554-0.2732,1.0487-0.4656,1.4391-0.6003c-2.7174-1.2273-4.58-1.0991-5.7817-0.7515 c-1.0002,0.2893-1.477,0.7117-2.626,0.9226C53.2763,51.8,51.6647,51.2634,50.6031,50.7712z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M73.4112,37.4897c-0.9321,0-1.7744-0.4785-2.2524-1.2803c-0.4771-0.7998-0.4985-1.7656-0.0571-2.583 L84.5538,8.9028c0.4536-0.8418,1.3354-1.3682,2.2988-1.3682c0.9575,0,1.8394,0.5215,2.3022,1.3604l13.4443,24.7275 c0.4463,0.8057,0.4331,1.7734-0.041,2.5781c-0.4756,0.8066-1.3193,1.2891-2.2568,1.2891H73.4112z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M86.8526,9.0349c0.3863,0,0.7738,0.1948,0.9888,0.585l13.44,24.72c0.41,0.74-0.13,1.6499-0.98,1.6499h-26.89 c-0.85,0-1.39-0.9099-0.99-1.6499l13.45-24.72C86.0814,9.2297,86.4664,9.0349,86.8526,9.0349 M86.8526,6.0349 c-1.5163,0-2.9044,0.8286-3.6227,2.1628L69.7862,32.9059c-0.6992,1.2937-0.6663,2.813,0.0841,4.0715 c0.7512,1.26,2.075,2.0122,3.5411,2.0122h26.89c1.4522,0,2.8122-0.7771,3.5492-2.0278c0.7465-1.2671,0.7671-2.7908,0.055-4.0759 L90.477,8.187C89.742,6.8535,88.3565,6.0349,86.8526,6.0349L86.8526,6.0349z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M87.6031,27.5182h-1.4979c-0.5523,0-1-0.4477-1-1v-9.5341c0-0.5523,0.4477-1,1-1h1.4979c0.5523,0,1,0.4477,1,1 v9.5341C88.6031,27.0704,88.1554,27.5182,87.6031,27.5182z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st5",
    cx: 86.8542,
    cy: 31.5677,
    r: 1.9372
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSessionTimeout);
export default __webpack_public_path__ + "static/media/SessionTimeout.8d9b5ef69994db44da3864600374e8fd.svg";
export { ForwardRef as ReactComponent };